import React from "react";
import DPTable, { Header } from "Components/DP/DPTable/DPTable";
import { DPComponentLoader, DPEmptyTable } from "Components/DP";
import { ProviderDisbursementsTableRow } from "./ProviderDisbursementsTableRow/ProviderDisbursementsTableRow";
import { DPProviderDisbursement } from "Shared/types/Disbursements";
import { useProviderDisbursements } from "../useProviderDisbursements";

const disbursementColumns = [
  { header: "Submitted At", width: 12 },
  { header: "User Name", width: 12 },
  { header: "User ID", width: 8 },
  { header: "Date Received", width: 12 },
  { header: "Bank", width: 10 },
  { header: "Amount", width: 8 },
  { header: "Reason", width: 8 },
  { header: "Requestor Name", width: 12 },
  { header: "Invoice ID", width: 10 },
  { header: "Status", width: 8 },
];

export const ProviderDisbursementsTable = () => {
  const colWidths = disbursementColumns
    .map(({ width }) => width);
  const headers = disbursementColumns
    .map(({ header }) => header);
  const { data, loading, page, rowsPerPage, onChangePage } = useProviderDisbursements();

  return (
    <DPTable
      colWidths={colWidths}
      count={data?.disbursements?.totalCount}
      headers={headers as Header[]}
      page={page}
      rowsPerPage={rowsPerPage}
      onChangePage={onChangePage}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          data?.disbursements?.items.length ? (
            <>
              {data.disbursements.items.map(
                (disbursement: DPProviderDisbursement, idx: number) => (
                  <ProviderDisbursementsTableRow
                    key={idx}
                    {...disbursement}
                  />
                )
              )}
            </>
          ) : (
            <DPEmptyTable message={"Disbursements will appear here"} />
          )
        }
      />
    </DPTable>
  );
};
